<template>
    <div class="db-card">
        <div id="dbRecords" v-if="count > 0">
          <div class="row p-0">
            <div class="col-12">
                <span class="title">{{ card_title }} <span style="font-weight: normal;">({{ count }})</span></span>&nbsp;&nbsp;&nbsp;
                
                <router-link :to="btnLink" v-if="count > 0 && btnLink && IsUserManager() && tab_name != 'mentees' && tab_name != 'apprentices'"" class="btn btn-primary btn-sm dbAddBtn float-right" style="text-decoration: none !important; padding-top: 6px;">
                  {{ btnName }}
                </router-link>
                
            </div>
          </div>
          <div class="col-12 p-0">
              <div class="db-report-card" v-for="(item, lindex) in allItems" :key="lindex">
                  <div class="row" v-if="tab_name=='mentees' || tab_name=='apprentices'" >
                    <div class="col-12 p-0">
                      <div class="col-10 db_name_block padding-lr-5 float-left" style="padding-left: 10px;">
                          <div class="col-2 p-0"  style="cursor:pointer; float: left; margin-right: 0px; margin-top: 8px;" @click="getMenteeProfileLink(item.id)">
                            <avatar  :username="item.initials" :customStyle="customStyle" :lighten="100" color="#FFF"></avatar>
                          </div>

                          <div class="float-left col-6 p-0" style="margin-top: 11px;">
                            <div class="col-12 p-0">
                              <div :class="'float-left col-10 p-0 db-mentee-name ' + getMarginClass() ">{{item.first_name + ' ' + item.last_name}}</div>
                              <div class="float-right col-2 p-0" style="text-align: right;">{{ item.overallCompententPercent }}%</div>
                              <div style="clear: both;"></div>
                            </div>
                            <div class="progress col-12 p-0">
                              <div class="progress-bar-green" :style="'width: ' + item.overallCompententPercent + '%;'" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>


                          <div class="col-4 p-0"  style=" text-align:right; float: left; margin-right: 0px;" >
                            <div :class="(item.rep_count == 0) ? 'goReview goReview-0' : 'goReview'" >
                              <div class="review_count">{{ item.rep_count }}</div>

                              <div class="review_text" v-if="item.rep_count > 1">Reps to <br/> Review</div>
                              <div class="review_text" v-else-if="item.rep_count == 1">Rep to <br/> Review</div>
                              <div class="review_text" v-else>Reps to <br/> Review</div>
                              <div class="goReviewBtn" v-if="item.rep_count > 0" v-on:click="menteeRepititionApproval(item.id, lindex)" >
                                <button class="col-12 p-0 btn btn-primary btn-sm goRepsBtn" >Go</button>
                              </div>
                            </div>
                          </div>

                      </div>
                      <div class="col-2 p-0 float-left" style="text-align: right; padding-right: 15px !important;">
                        <router-link :to="'/mentees-task/' + item.id" class="btn btn-primary btn-sm dbAddRepsBtn" v-if="btnType === 'add'">
                          Tasks
                        </router-link>
                        <router-link :to="getEditLink(isListType, item.id)" v-if="btnType === 'edit'" class="btn btn-primary btn-sm dbEditBtn">
                          Edit
                        </router-link>
                      </div>
                      <div style="clear: both;"></div>
                    </div>
                    <div class="col-12 p-0 mentee-first-icon">
                      <b-link
                        v-b-toggle="'mentee-first-' + item.id" @click="getFontIcon(item.id, lindex)" variant="primary"
                      >
                      <i class="fa fa-chevron-down" :id="'angle-'+ item.id" aria-hidden="true"></i>
                      </b-link>
                    </div>
                    <b-collapse v-bind:id="'mentee-first-' + item.id" class="col-12 p-0 mentee-first-collapse" >
                    <b-card>
                    <div class="col-12 p-0" style="margin-top: 7px; font-size: 12px; font-weight: bold; float: left;">
                      <div class="col-12 float-left p-0" v-for="(tasklist, tindex) in item.menteeTasklist" :key="tindex" style="margin-bottom: 6px;">
                        <div class="col-4 float-left padding-lr-5" style="padding-left: 20px;">
                          <b>{{ tasklist.name }}</b>
                        </div>
                        <div class="col-4 float-left padding-lr-5">
                          <div class="progress progress-blue col-12 p-0">
                            <div class="progress-bar-blue" :style="'width: ' + tasklist.competent_progress + '%;'" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                        <div class="col-1 float-left padding-lr-5">
                           {{ tasklist.competent_progress }}%
                        </div>
                        <div class="col-3 float-right padding-lr-5 view-certificate" style="text-align: right; padding-right: 20px;" @click="report_redirect(item.id, tasklist.id)">
                          View Results
                        </div>
                      </div>
                      <div v-if="item.menteeTasklist.length == 0" class="col-12 float-left p-0" style="font-style: italic; text-align: center;">
                        No Tasklists found!
                      </div>
                    </div>
                    <!-- Second Carrot -->
                    <div class="col-12 p-0 mentee-second-icon" style="float: left;">
                      <div style="clear: both;"></div>
                      <div v-show="item.loading" class="loading_show" style="float: none; height: 30px; text-align: center;"><div class="spinner-border text-danger"></div></div>
                      <div style="clear: both;"></div>
                      <div class="col-12 p-0" style="margin-top: 7px; font-size: 12px; font-weight: bold; float: left;" v-if="item.assessment_loading == true && item.assessmentCourses.length > 0">
                        <hr style="margin: 0px 20px 10px 20px; border-color: #ABABAB;" />
                        <div class="col-12 float-left p-0" v-for="(list, aindex) in item.assessmentCourses" :key="aindex" style="margin-bottom: 6px;">
                          <div class="col-7 float-left padding-lr-5" style="padding-left: 20px;">
                            <b>{{ list.title }}</b>
                          </div>
                          <div class="col-1 float-left padding-lr-5" style="padding-left: 20px;">
                            <i class="fa fa-check custom-tick" v-if="list.complete_status == 1" style="color: #19a974 !important; font-size: 15px;"></i>
                            <i class="fa fa-close custom-remove" v-else style="color: #ff4136 !important; font-size: 15px;"></i>
                          </div>
                          <div class="col-4 float-right padding-lr-5 view-certificate" style="text-align: right; padding-right: 20px;" v-if="list.complete_status == 1" @click="userAssessmentModalOpen(list.id, item.id, list.type)">
                            View Results
                          </div>
                          <div class="col-4 float-right padding-lr-5 view-error-certificate" style="text-align: right; padding-right: 20px;" v-else>
                            Incomplete
                          </div>
                        </div>
                      </div>
                      <div v-else-if="item.assessment_loading == true && item.assessmentCourses.length == 0" class="col-12 p-0" style="font-style: italic; text-align: center; font-size: 12px; font-weight: 900;">
                          No records found!
                      </div>
                    <div >  
                    <a v-bind:id="'mentee-second-up-' + item.id" @click="getSecondFontIcon(item.id, lindex, 'hide')" style="width: 100%; cursor: pointer; float: left; text-align: center; display: none;"  
                    >
                    <i class="fa fa-chevron-up" :id="'angle-second-'+ item.id" aria-hidden="true"></i>
                    </a>
                    <a v-bind:id="'mentee-second-down-' + item.id" @click="getSecondFontIcon(item.id, lindex, 'show')" style="width: 100%; cursor: pointer; float: left; text-align: center; display: block;"  
                    >
                    <i class="fa fa-chevron-down" :id="'angle-second-'+ item.id" aria-hidden="true"></i>
                    </a>
                    </div>
                    </div>


                    </b-card>
                    </b-collapse>

                  </div>



                  <div class="row" v-else>
                      <div class="col-9 col-sm-9 col-md-9 col-lg-8 col-xl-9 db_name_block padding-lr-5" style="padding-left: 10px;">
                          <div class="col-2 p-0" style="float: left; margin-right: 0px;">
                            <avatar  :username="item.initials" :customStyle="customStyle" :lighten="100" color="#FFF"></avatar>
                          </div>

                          <div class="float-left col-10 p-0">
                            <div :class="'db-mentee-name ' + getMarginClass() ">{{item.first_name + ' ' + item.last_name}}</div>
                            <div v-if="tab_name=='managers'">
                              <button class="goal-indicator-btn greenBtn">Mentor</button>
                            </div>
                          </div>
                      </div>
                      <div class="col-3 col-sm-3 col-md-3 col-lg-4 col-xl-3 float-left">
                        <router-link :to="'/mentees-task/' + item.id" class="btn btn-primary btn-sm dbAddRepsBtn" v-if="btnType === 'add'">
                          Tasks
                        </router-link>
                        <router-link :to="getEditLink(isListType, item.id)" v-if="btnType === 'edit'" class="btn btn-primary btn-sm dbEditBtn">
                          Edit
                        </router-link>
                      </div>
                      <div class="col-12 p-0" v-if="tab_name=='managers' || tab_name=='mentors'" >
                        <div class="col-12 p-0 mentor-second-icon">
                        <div >  
                        <a v-bind:id="'mentor-second-up-' + item.id" @click="getMentorSecondFontIcon(item.id, lindex, 'hide')" style="width: 100%; cursor: pointer; float: left; text-align: right; display: none;"  
                        >
                        <i class="fa fa-chevron-up" :id="'angle-second-'+ item.id" aria-hidden="true"></i>
                        </a>
                        <a v-bind:id="'mentor-second-down-' + item.id" @click="getMentorSecondFontIcon(item.id, lindex, 'show')" style="width: 100%; cursor: pointer; float: left; text-align: right; display: block;"  
                        >
                        <i class="fa fa-chevron-down" :id="'angle-second-'+ item.id" aria-hidden="true"></i>
                        </a>
                        </div>


                      <div style="clear: both;"></div>
                      <div class="col-12 p-0" v-bind:id="'mentor-assessment-' + item.id" style="display: none;">
                      <div v-show="item.mentor_loading" class="loading_show" style="float: none; height: 30px; text-align: center;"><div class="spinner-border text-danger"></div></div>
                      <div style="clear: both;"></div>

                      <div class="col-12 p-0" v-if="item.mentor_assessment_loading == true && item.mentor_assessmentCourses.length > 0" style="margin-top: 7px; font-size: 12px; font-weight: bold; float: left;" >
                        <div class="col-12 float-left p-0" v-for="(list, aindex) in item.mentor_assessmentCourses" :key="aindex" style="margin-bottom: 6px;" >
                          <div class="col-7 float-left padding-lr-5" style="padding-left: 20px;">
                            <b>{{ list.title }}</b>
                          </div>
                          <div class="col-1 float-left padding-lr-5" style="padding-left: 20px;">
                            <i class="fa fa-check custom-tick" v-if="list.complete_status == 1" style="color: #19a974 !important; font-size: 15px;"></i>
                            <i class="fa fa-close custom-remove" v-else style="color: #ff4136 !important; font-size: 15px;"></i>
                          </div>
                          <div class="col-4 float-right padding-lr-5 view-certificate" style="text-align: right; padding-right: 20px;" v-if="list.complete_status == 1" @click="userAssessmentModalOpen(list.id, item.id, list.type)">
                            View Results
                          </div>
                          <div class="col-4 float-right padding-lr-5 view-error-certificate" style="text-align: right; padding-right: 20px;" v-else>
                            Incomplete
                          </div>
                        </div>
                      </div>
                      <div v-else-if="item.mentor_assessment_loading == true && item.mentor_assessmentCourses.length == 0" class="col-12 p-0" style="font-style: italic; text-align: center; font-size: 12px; font-weight: 900;">
                          No records found!
                      </div>

                      </div>
                          
                        </div>
                      </div>
                  </div>

              </div>
          </div>
        </div>
        <div id="dbNoRecord" v-if="count === 0">
          <div class="row p-0">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <span class="title">{{ card_title }} </span>
              </div>
          </div>
          <div class="col-12 mt-2 db-empty-card">
            <div v-if="IsUserManager()">
              <h6 class="empty-content-title">No {{ card_title }} Found. Let's add one!</h6>
              <router-link :to="btnLink" v-if="count == 0 && btnName != 'Add Mentee'  && btnName != 'Add Apprentice'" class="btn btn-primary btn-sm dbAddBtn">
                {{ btnName }}
              </router-link>
            </div>
            <div v-else>
              <h6 v-if="card_title == 'Mentees'" class="empty-content-title">No Mentee Assigned to You… Yet!</h6>
              <h6 v-if="card_title == 'Apprentices'" class="empty-content-title">No Apprentice Assigned to You… Yet!</h6>
            </div>
          </div>
        </div>

      <MenteeReviewRepetition
          :isModalVisible="isReviewRepsModalVisible"
          :menteeId="menteeId"
          :menteeIndex="menteeIndex"
          ref="review_reps_form"
          @close="isReviewRepsModalVisible = false">
      </MenteeReviewRepetition>

      <UserAssessmentDetails
          :isModalVisible="isUserAssessmentModalVisible"
          :assessmentId="assessmentId"
          :menteeId="assessmentMenteeId"
          ref="user_assessment_details"
          @close="isUserAssessmentModalVisible = false">
      </UserAssessmentDetails>

      <UserCourseDetails
          :isModalVisible="isUserCourseModalVisible"
          :courseId="courseId"
          :menteeId="courseMenteeId"
          ref="user_course_details"
          @close="isUserCourseModalVisible = false">
      </UserCourseDetails>



    </div>
</template>
<script>

import router from '../../router/index.js';
import Avatar from 'vue-avatar';
import axios from 'axios';
import { store } from '../../store/store';
import MenteeReviewRepetition from './MenteeReviewRepetitionAllTasklists.vue';
import UserAssessmentDetails from './UserAssessmentDetailsModal.vue';
import UserCourseDetails from './UserCourseDetailsModal.vue';

export default {
    props: [
        'card_title', 
        'count', 
        'show_more', 
        'itemLength',
        'lessResult', 
        'allItems', 
        'btnName',
        'btnLink',
        'btnType',
        'isListType',
        'see_more_text',
        'tab_name'
    ],
    data: function () {
        return {
            customStyle: {
              'font-size': '16px',
              'font-weight': 'bold',

            },
            assessment_loading: false,
            assessmentCourses: [],
            mentor_assessment_loading: false,
            mentor_assessmentCourses: [],
            repCount: '',
            isReviewRepsModalVisible: false,
            menteeId: '',
            menteeIndex: '',
            loading: false,
            mentor_loading: false,
            isUserAssessmentModalVisible: false,
            assessmentId: '',
            assessmentMenteeId: '',
            courseId: '',
            isUserCourseModalVisible: false,
            courseMenteeId: '',
        }
    },        
    methods: {
        clickShowMore() {
          this.$emit('click');
        },
        userAssessmentModalOpen(id, menteeId, type) {
          if(type == 'Course') {
            this.isUserCourseModalVisible = true;
            this.courseId = id;
            this.courseMenteeId = menteeId;
            this.$refs.user_course_details.getUserCourseDetails(id, menteeId);
          }
          else {
            this.isUserAssessmentModalVisible = true;
            this.assessmentId = id;
            this.assessmentMenteeId = menteeId;
            this.$refs.user_assessment_details.getUserAssessmentDetails(id, menteeId);
          }
        },
        menteeRepititionApproval(id, index) {
          this.isReviewRepsModalVisible = true;
          this.menteeId = id;
          this.menteeIndex = index;
          this.repCount = this.allItems[index].rep_count;
          this.$refs.review_reps_form.getPendingReviews(this.repCount);
          this.$refs.review_reps_form.getMenteeRepetitionList(id);
          const vmessage = 'hide_vmessage';
          this.$refs.review_reps_form.getScoreLists(vmessage);
          setTimeout(()=>{
            this.isReviewRepsModalVisible = true;
            return false;
          }, 1000);
        },
        report_redirect: function(menteeId, tasklistId) {
          let routeData = this.$router.resolve({name: 'competencyreport', query: {menteeId: menteeId, tasklistId: tasklistId}});
          window.open(routeData.href, '_blank');
        },
        getSecondFontIcon(id, index, type) {
          this.assessmentCourses = [];
          if (type == "show") {
            this.allItems[index].loading = true;
            this.getAssessmentCourseDetails(id, index);
          } else {
            document.getElementById("mentee-second-up-" + id).style.display = 'none';
            document.getElementById("mentee-second-down-" + id).style.display = 'block';
            this.allItems[index].assessment_loading = false;
          }
        },
        getAssessmentCourseDetails: function(menteeId, index) {
          var id = menteeId;
          axios.get('/desktop/user/assessment-course-lists/' + this.$store.state.user_accountid + '/' + menteeId, {
          })
          .then(response =>  {
            this.allItems[index].assessment_loading = true;
            this.allItems[index].loading = false;
            this.allItems[index].assessmentCourses = response.data.assessmentCourse;
            document.getElementById("mentee-second-up-" + id).style.display = 'block';
            document.getElementById("mentee-second-down-" + id).style.display = 'none';
          })
          .catch(function() {
            console.log("Come here");
          });
        },

        getMentorSecondFontIcon(id, index, type) {
          this.mentor_assessmentCourses = [];
          if (type == "show") {
            this.allItems[index].mentor_loading = true;
            document.getElementById("mentor-assessment-" + id).style.display = 'block';
            this.getMentorAssessmentCourseDetails(id, index);
          } else {
            document.getElementById("mentor-second-up-" + id).style.display = 'none';
            document.getElementById("mentor-second-down-" + id).style.display = 'block';
            document.getElementById("mentor-assessment-" + id).style.display = 'none';
            this.allItems[index].mentor_assessment_loading = false;
          }
        },
        getMentorAssessmentCourseDetails: function(menteeId, index) {
          var id = menteeId;
          axios.get('/desktop/user/assessment-course-lists/' + this.$store.state.user_accountid + '/' + menteeId, {
          })
          .then(response =>  {
            this.allItems[index].mentor_assessmentCourses = response.data.assessmentCourse;
            this.allItems[index].mentor_loading = false;
            this.allItems[index].mentor_assessment_loading = true;
            document.getElementById("mentor-second-up-" + id).style.display = 'block';
            document.getElementById("mentor-second-down-" + id).style.display = 'none';
          })
          .catch(function() {
            console.log("Come here");
          });
        },

        getFontIcon(id, index) {
          if (document.getElementById('mentee-first-' + id).style.display == "") {
            document.getElementById('angle-'+ id).className = "fa fa-chevron-down";
            document.getElementById("mentee-second-up-" + id).style.display = 'none';
            document.getElementById("mentee-second-down-" + id).style.display = 'block';
            this.allItems[index].loading = false;
            this.allItems[index].assessmentCourses = [];
            this.allItems[index].assessment_loading = false;
          } else {
            document.getElementById('angle-'+ id).className = "fa fa-chevron-up";
            this.allItems[index].loading = false;
            this.allItems[index].assessmentCourses = [];
            this.allItems[index].assessment_loading = false;
          }
        },
        initialAvatar(firstname, lastname) {
          var initial = '';
          initial = firstname.charAt(0) + ' ' + lastname.charAt(0);
          return initial;
        },
        getEditLink(isListType, id) {
          var editLink = '/edit-mentor/' + id;
          if (isListType == "manager") {
            editLink =  '/update-manager/' + id;
          }
          return editLink;
        },
        getMenteeProfileLink(id) {
          router.push('/view-mentee-profile/' + id);
        },
         IsUserManager() {
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_ADMIN') > -1 && (this.$store.state.switch_flag && this.$store.state.switch_flag.toLowerCase() == 'manager'))
          {
            return true;
          } else {
            if (
              this.$store.state.switch_admin_roles && 
              this.$store.state.switch_admin_roles.indexOf("ROLE_ADMIN") > -1 && 
              (this.$store.state.switch_flag 
              && this.$store.state.switch_flag.toLowerCase() == 'manager')
            ) {
              return true;
            } else {
              return false;
            }
          }
       },
       getMarginClass() {
         return (this.tab_name == 'mentees' || this.tab_name == 'apprentices') ? '' : 'marginTop20';
       }
    },
   components: {
    Avatar,
    MenteeReviewRepetition,
    UserAssessmentDetails,
    UserCourseDetails,
   },

}
</script>
<style scoped>
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
  margin-top: 0px;
  text-transform: capitalize;
}
.db-card .see-more, .db-card .see-more :hover{
  color: #002F42;
  font-size: 13px;
  font-weight: 600;
  float: right;
  text-decoration: none !important;
}
.circle {
  background-color: #A5A5A5;
  border-radius: 30px;
  text-align: center;
  width: 60px;
  height: 60px;
  margin-right: 5px;
  float: left;
}
.initials {
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  position: relative;
  transform: translateY(22px);
  color: #FFF;
  display: inline-block;
  vertical-align: middle;
}
.db_name_block {
  float: right;
}
.dbAddBtn, .dbAddBtn, .dbEditBtn{
  color: #00ACEE;
  border: 0px solid #29A3E4;
  background: none;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 15px;
}
.dbAddBtn:active, .dbAddBtn:focus, .dbAddBtn:hover, .dbEditBtn:focus, .dbEditBtn:hover {
  color: #00acee !important;
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 
.dbAddRepsBtn {
  color: #FFF;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 10px;
  width: 65px;
  margin-top: 15px;
}
.dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
}
.dbGoalBtn {
  text-decoration: underline;
  color: #002F42 !important;
}
.marginTop20 {
  margin-top: 15px !important;
}
/* media query css start */
@media (min-width: 992px) {
  .dbAddBtn {
    width: 150px;
  }
  .dbAddBtn {
    width: 120px;
  }
}
@media (max-width: 991px) {
  .dbAddBtn {
    width: 120px;
  }
}
.goal-indicator-btn {
    border-radius: 10px;
    font-size: 13px;
    padding: 5px;
    line-height: 12px;
    height: auto;
    width: 80px;
    text-align: center;
    outline: none !important;
}
.greenBtn, .greenBtn:active, .greenBtn:focus{
    color: #FFFFFF !important;
    background-color: #68C47E !important;
    border: 1px solid #68C47E !important;
    cursor: text;
}
.progress {
  margin-top: 3px;
  border: 0px solid #FFF;
  background-color: #FFFFFF;
  height: 15px;
}
.progress-blue {
  height: 10px;
}
.progress-bar-green {
  background-color: #228B22;
}
.progress-bar-blue {
  background-color: #29A3E4;
}
.view-certificate {
    text-align: right;
    font-size: 11px;
    color: #29A3E4;
    cursor: pointer;
    text-decoration: underline !important;
}
.view-error-certificate {
  color: #EE4200;
  text-decoration: none !important;
  text-align: right;
  font-size: 11px;
}
.view-certificate a, .view-certificate a:hover{ 
  color: #29A3E4 !important;
  text-decoration: underline !important;
  font-weight: bold;
}
.mentee-first-collapse .card, .mentee-second-collapse .card {
  background: none;
  width: 100% !important;
}
.mentee-first-icon i, .mentee-second-icon i, .mentor-second-icon i {
  float: right;
  padding-right: 15px;
  font-weight: normal;
  font-size: 12px;
  color: #29A3E4 !important;
}
.mentee-second-icon i {
  float: none;
}
.mentee-first-icon i:hover, .mentee-second-icon i:hover, .mentor-second-icon i:hover {
  color: #29A3E4 !important;
}
.goReview{
  background-color: #FFF;
  border: 1px solid #29A3E4;
  border-radius: 10px;
  padding: 2px;
  line-height: 13px;
  margin: 15px 5px;
  float: right;
}
.goReviewBtn {
  text-align: right;
}
@media (max-width: 1360px) {
  .goReview {
    width: 85%;
  }
  .goReview-0 {
    width: 50%;
  }
  .goReviewBtn {
    width: 30%;
  }
}
@media (min-width: 1361px) {
  .goReview {
    width: 81%;
  }
  .goReview-0 {
    width: 45%;
  }
  .goReviewBtn {
    width: 35%;
  }
}
@media (min-width: 1680px) {
  .goReviewBtn {
    width: 35%;
  }
}
.goReview div {
  margin-left: 5px;
  float: left;
}
.review_count { 
  color: #00acee; 
  font-size: 20px; 
  margin-top: 6px; 
}
.review_text { 
  font-weight: 100;
  color: #002F42;
  text-align: left;
  font-size: 12px;
}
.goRepsBtn, .goRepsBtn:active {
  color: #FFF; 
  background-color: #EE4200 !important;
  border: 1px solid #EE4200 !important;
  border-radius: 10px;
  padding: 2px 5px;
  margin-top: 1px;
  height: 25px;
}
.mentee-first-icon .custom-remove .mentee-first-icon .custom-remove:hover {
    color: #EE4200 !important;
}
i.custom-tick, .custom-tick:hover {
    color: #19a974 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/manager/db_card_list.vue